import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useEffect, useMemo } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import Form from '../../../containers/Form/Form'
import Button from '../../../containers/Form/Button'

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_second_offer_exc_list, tool_second_offer_exc_save, tool_second_offer_exc_delete } from "../../../app/apiEndpoints"
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'
import ConfirmDialog from '../../../containers/ConfirmDialog';

const SecondOfferExclusionTool = (props) => {
    const toolID = 30
    const [tool, setTool] = useState({})

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [subpids, setSubpids] = useState([])
    const [subpidInput, setSubpidInput] = useState('')
    const [overwrite, setOverwrite] = useState(false)
    const [search, setSearch] = useState('')
    const [formMessage, setFormMessage] = useState('')
    const [processing, setProcessing] = useState(false)
    const [deleteSubpid, setDeleteSubpid] = useState('')
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [showConfirmOverwrite, setShowConfirmOverwrite] = useState(false)

    const tableID = "soexc"
    const tableFields = ["Subpid", "Added"]

    useEffect(() => {
        const getDetails = async () => {
            const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
            setTool(data.tool)
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getList = async () => {
            const data = await toolsAPICall(tool_second_offer_exc_list, { 'requester': userID, 'company': companyID })
            if(data.error) setFormMessage(data.error)
            else setSubpids(data.subpids || [])
        }
        getList()
    }, [userID, companyID])

    const parsedSubpids = () => {
        const seen = new Set()
        return subpidInput.split(/\r?\n/).map(s => s.trim()).filter(s => {
            if(!s || seen.has(s)) return false
            seen.add(s)
            return true
        })
    }

    const filteredSubpids = useMemo(() => {
        const term = search.trim().toLowerCase()
        if(!term) return subpids
        return subpids.filter(row => row.subpid.toLowerCase().includes(term))
    }, [subpids, search])

    const tableData = () => {
        return filteredSubpids.map(row => ({
            'id': row.subpid,
            'deleteFnc': confirmDelete,
            'values': [ row.subpid, row.added_at ]
        }))
    }

    const submitSubpids = (e) => {
        e.preventDefault()
        setFormMessage("")
        if(parsedSubpids().length === 0) {
            setFormMessage("Please enter at least one subpid")
            return
        }
        if(overwrite) setShowConfirmOverwrite(true)
        else saveSubpids()
    }

    const saveSubpids = async () => {
        setShowConfirmOverwrite(false)
        if(processing) return
        setProcessing(true)
        const list = parsedSubpids()
        const data = await toolsAPICall(tool_second_offer_exc_save, {
            'requester': userID,
            'company': companyID,
            'subpids': list.join("\n"),
            'overwrite': overwrite ? 1 : 0
        })
        if(data.error) {
            setFormMessage(data.error)
        } else {
            if(data.subpids) setSubpids(data.subpids)
            const added = data.added !== undefined ? data.added : list.length
            setFormMessage(overwrite ? `List overwritten with ${list.length} subpids` : `${added} new subpids added (${list.length - added} already in list)`)
            setSubpidInput('')
            setOverwrite(false)
        }
        setProcessing(false)
    }

    const confirmDelete = (e) => {
        e.preventDefault()
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`delete_`, "")
        if(rowID) {
            setDeleteSubpid(rowID)
            setShowConfirmDelete(true)
        }
    }

    const performDelete = async () => {
        setShowConfirmDelete(false)
        if(!deleteSubpid) return
        const data = await toolsAPICall(tool_second_offer_exc_delete, {
            'requester': userID,
            'company': companyID,
            'subpid': deleteSubpid
        })
        if(!data.success && data.error) {
            setFormMessage(data.error)
            return
        }
        if(data.subpids) setSubpids(data.subpids)
        else setSubpids(subpids.filter(row => row.subpid !== deleteSubpid))
        setFormMessage(`Removed ${deleteSubpid}`)
        setDeleteSubpid('')
    }

    if(!tool) return <></>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Form title={tool.tool_name} description={tool.description} onSubmit={submitSubpids}>
        <Row>
            <Col md={12}>
                <Card.Body>
                    <Row>
                        <Col md={2} className="control-label col-form-label">Subpids</Col>
                        <Col md={6}>
                            <textarea className="form-control" id="subpids" name="subpids" readOnly={processing} style={{height: 200 }} value={subpidInput} onChange={(e) => setSubpidInput(e.target.value)} placeholder='Enter subpids on separate lines' />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2}></Col>
                        <Col md={6}>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="overwrite" checked={overwrite} disabled={processing} onChange={(e) => setOverwrite(e.target.checked)} />
                                <label className="form-check-label" htmlFor="overwrite">Overwrite existing list (only the subpids pasted above will remain)</label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} className="text-center pt-3">
                            <Card.Text>{formMessage}</Card.Text>
                            {!processing ? <Button title={overwrite ? "Overwrite List" : "Add Subpids"} className={overwrite ? "danger" : "info"} /> : null}
                        </Col>
                    </Row>
                </Card.Body>
            </Col>
        </Row>
        </Form>
        <Row>
            <Col md={12}>
                <Card>
                    <Card.Header>
                        <Row>
                            <Col md={8}>
                                <h4 className="title">Excluded Subpids</h4>
                                <p className="category">{subpids.length} subpids currently excluded from the second offer{search ? ` (${filteredSubpids.length} shown)` : ''}</p>
                            </Col>
                            <Col md={4} className="text-right">
                                <input type="text" className="form-control" placeholder="Search subpids" value={search} onChange={(e) => setSearch(e.target.value)} />
                            </Col>
                        </Row>
                    </Card.Header>
                    <DataTable tableID={tableID} fieldNames={tableFields} hideTotal={true} dataRows={tableData()} tableSettings={tableTypes.None} />
                </Card>
            </Col>
        </Row>
        <ConfirmDialog
            show={showConfirmDelete}
            title="Remove Subpid" message={`Are you sure you wish to remove ${deleteSubpid} from the list?`}
            onClose={() => { setShowConfirmDelete(false) }}
            onConfirm={performDelete}
        />
        <ConfirmDialog
            show={showConfirmOverwrite}
            title="Overwrite List" message={`This will remove all ${subpids.length} existing subpids and replace them with the ${parsedSubpids().length} you pasted. Continue?`}
            onClose={() => { setShowConfirmOverwrite(false) }}
            onConfirm={saveSubpids}
        />
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(SecondOfferExclusionTool), "Second Offer Exclusion Tool"));
